module.exports = __webpack_public_path__ + "static/media/siddharth-sakleshpur-trip-08.5f0438dc.png";